define('bindingHandlers/transferBox',[
    'jquery',
    'lib/lodash4',
    'lib/knockout',
    'util/keyCode',
    'util/codeUtils',
    'bindingHandlers/include',
    'extensions/i18n/knockout.i18n'
], function (
    $,
    _,
    ko,
    keyCode,
    codeUtils
) {

    'use strict';

    var TEMPLATE_NAME = 'templates/widgets/transferBox';

    ko.bindingHandlers.transferBox = {

        /**
         * # The transferBox Binding
         *
         * The transferBox binding is a complex binding that allows
         * for the binary toggling of states for an array of items.
         *
         * ## Required Arguments
         *
         * @param {ObservableArray} options  -- An array of objects
         *      that are available to be selected by the user. These
         *      obejcts should possess the attributes id (unique) and
         *      name.
         *
         * @param {ObservableArray} selectedOptions -- An arary of
         *      objects that are currently selected. These obejcts
         *      should possess the attributes id (unique) and name.
         *
         * @param {ObservableArray} toggledOptions -- An array of
         *      objects that have been toggled into a different state.
         *      The consumer will likely passed a reference to an empty
         *      observableArray which will be populated by the binding
         *      as the user interacts with the transferBox.
         *
         * @param {function} filter -- A function callback that will
         *      be called when to changes are made to the filter input.
         *
         * @param {String} keys.mainHeader -- A string key for the main
         *      heading for the transferBox.
         *
         * @parem {String} keys.currentHeader (optional) -- A string key
         *      for the selected options container header.
         *
         * @parem {String} keys.availableHeader (optional) -- A string
         *      key for the non-selected options container header.
         *
         * ## Optional Arguments
         *
         * @param {function} loadMoreSelectOptions -- A function fallback
         *      that will be called when the user scrolls to the end of
         *      the selected options container.
         *
         * @param {function} loadMoreOptions -- A function fallback
         *      that will be called when the user scrolls to the end of
         *      the non-selected options container.
         *
         * @param {ObservableArray} totalInitialItemsSelected -- An
         *      array container to hold items that have been toggled
         *      from their original state.
         *
         * @param {boolean} sortable -- A boolean value that will enable
         *      whether the user can order items in the 'active' column.
         *
         * ## Example
         *
         * <div data-bind="
         *      transferBox:{
         *          options: availableList,
         *          selectedOptions: selectedList,
         *          toggledOptions: toggledList,
         *          filter: filterCallback
         *          keys: {
         *              mainHeader: 'namespace.heading',
         *              currentHeader: 'namespace.currentHeader',
         *              availableHeader: 'namespace.availableHeader'
         *          },
         *          loadMoreSelectedOptions: loadMoreSelectedOptions,
         *          loadMoreOptions: loadMoreOptions,
         *          totalInitialItemsSelected: totalCurrentItems
         *      }
         *  "></div>
         */

        init: function(element, valueAccessor, allBindings, viewModel, bindingContext){

            var self = this;

            // **************************************************************************
            // Variables
            // **************************************************************************

            var bindingData = ko.unwrap(valueAccessor()),
                $element = $(element),
                options = bindingData.options,
                selectedOptions = bindingData.selectedOptions,
                unselectedOptions = ko.observableArray(),
                toggledOptions = bindingData.toggledOptions || ko.observableArray(),
                filterCallback = bindingData.filter,
                filter = ko.observable(),
                itemCount = bindingData.totalInitialItemsSelected ? bindingData.totalInitialItemsSelected : 0,
                sortable = bindingData.sortable ? true : false;

                if (!ko.isObservable(itemCount)) {
                    itemCount = ko.observable(itemCount);
                }

            // **************************************************************************
            // Helper Functions
            // **************************************************************************

            var getAvailableOptions = function(){

                var selectedIds = _.map(selectedOptions(),'id');

                return _.filter(options(), function(item){
                    return (selectedIds.indexOf(item.id) === -1);
                });
            };

            var toggle = function(item){

                var changedIds = _.map(toggledOptions(),'id');
                if(changedIds.indexOf(item.id) > -1){
                    toggledOptions.splice(changedIds.indexOf(item.id),1);
                } else {
                    toggledOptions.push(item);
                }

                var selectedIds = _.map(selectedOptions(),'id'),
                    index,
                    newItem;

                if(selectedIds.indexOf(item.id) > -1){
                    index = selectedIds.indexOf(item.id);
                    newItem = selectedOptions.splice(index,1);
                    unselectedOptions.push(newItem[0]);
                    itemCount(itemCount()-1);
                } else {
                    var unselectedIds = _.map(unselectedOptions(),'id');
                    index = unselectedIds.indexOf(item.id);
                    newItem = unselectedOptions.splice(index,1);
                    selectedOptions.push(newItem[0]);
                    itemCount(itemCount()+1);
                }

            };

            var moveUp = function(item){
                var selectedIds = _.map(selectedOptions(),'id');
                var index = selectedIds.indexOf(item.id);
                if(index > 0){
                    var arrItem = selectedOptions.splice(index, 1)[0];
                    selectedOptions.splice(index-1, 0, arrItem);
                }
            };

            var moveDown = function(item){
                var selectedIds = _.map(selectedOptions(),'id');
                var index = selectedIds.indexOf(item.id);
                if(index < selectedOptions().length){
                    var arrItem = selectedOptions.splice(index, 1)[0];
                    selectedOptions.splice(index+1, 0, arrItem);
                }
            };

            var disableEnterSubmit = function(){

                var evt = arguments[1];

                if(evt.keyCode !== keyCode.ENTER){
                    return true;
                } else {
                    return false;
                }

            };

            // **************************************************************************
            // Process Binding Options
            // **************************************************************************

            $element.addClass('transfer-box');

            // Check for input options

            if(_.isUndefined(options)){
                throw new Error("The TransferBox binding requires that an observableArray be passed as the options argument.");
            }

            if(_.isUndefined(selectedOptions)){
                throw new Error("The TransferBox binding requires that an observableArray be passed as the selectedOptions argument.");
            }

            // Check for string keys

            if(_.isUndefined(bindingData.keys)){
                throw new Error("The TransferBox binding requires that an object be passed as the keys argument containing minimally a key for 'mainHeader', and optionally, for 'currentHeader' and 'availableHeader'.");
            } else if(!_.isUndefined(bindingData.keys) && _.isUndefined(bindingData.keys.mainHeader)) {
                throw new Error("The TransferBox binding requires that an object be passed as the keys argument containing minimally a key for 'mainHeader', and optionally, for 'currentHeader' and 'availableHeader'.");
            } else {
                bindingData.keys.currentHeader = bindingData.keys.currentHeader || 'transferBox.defaultCurrentHeader';
                bindingData.keys.availableHeader = bindingData.keys.availableHeader || 'transferBox.defaultAvailableHeader';
            }

            // Check for callback functions

            if(_.isUndefined(filterCallback) || (typeof filterCallback !== 'function')){
                throw new Error("The TransferBox binding requires that a function be passed as the filter argument.");
            }

            // **************************************************************************
            // Build Options/Available Arrays For Transfer Box
            // **************************************************************************

            unselectedOptions(getAvailableOptions());

            var subscriptions = [];

            subscriptions.push(options.subscribe(function(){
                unselectedOptions(getAvailableOptions());
            }));

            subscriptions.push(
                filter.subscribe(function(value){
                    unselectedOptions.removeAll();
                    options.removeAll();
                    filterCallback(value);
                })
            );

            // **************************************************************************
            // Include Transfer Box Template
            // **************************************************************************

            var transferBoxOptions = _.assign(bindingData, {
                'unselectedOptions': unselectedOptions,
                'selectedCount': itemCount,
                'toggle': toggle,
                'moveUp': moveUp,
                'moveDown': moveDown,
                'loadMoreSelectedOptions': bindingData.loadMoreSelectedOptions || _.noop,
                'loadMoreOptions': bindingData.loadMoreOptions || _.noop,
                'filter': filter,
                'disableEnterKey': disableEnterSubmit,
                'sortable': sortable,
                'generateListItemClass': _.partial(codeUtils.generateClassFromString, "transfer-box-list-item-")
            });

            var includeValueAccessor = ko.observable({
                name: TEMPLATE_NAME,
                data: {
                    transferBox: transferBoxOptions
                }
            });

            ko.bindingHandlers.include.init.call(self, element, includeValueAccessor, allBindings, viewModel, bindingContext);
            ko.bindingHandlers.include.update.call(self, element, includeValueAccessor, allBindings, viewModel, bindingContext);

            ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
                _.forEach(subscriptions, function (subscription) {
                    subscription.dispose();
                });
            });

        }

    };

});

